export const RESUME_URL = "/Kuhuk-Sharma-Resume.pdf";
export const RESUME_FILENAME = "Kuhuk-Sharma-Resume.pdf";

// Native download attribute on the triggering <a> handles the download;
// this also pops the PDF open in a new tab (Chrome renders it inline).
export const openResumePreview = () => {
  window.open(RESUME_URL, "_blank", "noopener,noreferrer");
};
